import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.css']
})
export class CustomButtonComponent {
  @Input() text: boolean = false;
  @Input() label!: string;
  @Input() icon!: string;
  @Input() type: string = '';
  @Input() disabled: boolean = false;
}
